export default "__VITE_ASSET__bafe6a8c__"